import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Globle } from 'src/assets/globle';
import { ServiceOrderReport } from './servicesbymandoob/serviceOrderReport';

@Injectable({
  providedIn: 'root'
})
export class ServiceordersreportsService {

  constructor(private http: HttpClient, private global: Globle) {

  }

  get(mandoobId: string, mainServiceId: number, fromDate: string, toDate: string) {
    return this.http.get<ServiceOrderReport[]>(this.global.APIURL +
      "serviceorder/getbymandoob?mandoobId=" + mandoobId + "&mainServiceId=" + mainServiceId +
      "&fromDate=" + fromDate + "&toDate=" + toDate);
  }
}
